<template>
  <div class="chart" :class="{ 'chart--social-mode': socialMode, 'chart--no-footer': noFooter, 'chart--active-route-view': isActiveRouteView }">
    <component class="chart__main"
      :is="chart"
      :social-mode="socialMode"
      :height="height" />
    <embeddable-footer v-if="showFooter" class="chart__footer position-absolute" />
  </div>
</template>

<script>
import { EmbeddableFooter } from '@icij/murmur'
import find from 'lodash/find'
import { routes, ChartRoute } from '../router'

export default {
  name: 'Chart',
  components: {
    EmbeddableFooter
  },
  props: {
    chart: {
      type: Object
    },
    socialMode: {
      type: Boolean
    },
    noFooter: {
      type: Boolean
    },
    height: {
      type: Number,
      default: null
    }
  },
  mounted () {
    this.saveFooterHeight()
  },
  updated () {
    this.saveFooterHeight()
  },
  computed: {
    showFooter () {
      return !this.noFooter && !this.socialMode
    },
    isActiveRouteView () {
      const route = find(routes, { name: this.$route.name })
      return route instanceof ChartRoute
    }
  },
  methods: {
    async saveFooterHeight () {
      // Wait for the component to render once
      await this.$nextTick()
      // Height equal 0 if no footer
      const footer = this.$el.querySelector('.embeddable-footer')
      const height = this.showFooter ? `${footer.offsetHeight}px` : '0px'
      // Save component height in a CSS variable after it's been update
      this.$root.$el.style.setProperty('--app-footer-height', height)
    }
  }
}
</script>

<style lang="scss">
  @import '../variables.scss';

  .chart {
    position: relative;
    padding-bottom: 56px;

    &--active-route-view {
      min-height: 100vh;
    }

    &--social-mode {
      padding-bottom: 0;
    }

    &--no-footer {
      padding-bottom: 0;
    }

    &__main {
      background: #fff;
    }

    &--social-mode &__main {
      background: $secondary;
      color: #fff;

      .stacked-bar-chart__groups__item__bars__item__value {
        color: currentColor;
      }
    }
  }
</style>
